import { css } from "@emotion/css"

import { useCallback } from "react"
import { Checkbox, MenuItem, TextField } from "@material-ui/core"

const styles = {
  root: css`
    width: 256px;
  `,
  input: css`
    height: 51px;
    padding: 0px 16px;
    background-color: white;
    display: flex;
    align-items: center;
  `,
  label: css`
    font-size: 13px;
    color: var(--neutral-400, #a8a8a8);
  `,
  paper: css`
    min-width: 160px !important;
    li {
      font-size: 14px;
      :hover {
        background-color: var(--primary-light) !important;
      }
    }
  `,
  valuesContainer: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 143px;
  `,
}

const ITEM_HEIGHT = 36

export default function MultipleSelect({
  label,
  value,
  options,
  onChangeParent,
  disabled,
}: {
  label: string
  value: string[]
  options: string[]
  onChangeParent: (value: string[]) => void
  disabled: boolean
}) {
  const handleChange = useCallback(
    (e) => {
      onChangeParent(e.target.value)
    },
    [onChangeParent],
  )

  return (
    <TextField
      select
      variant="outlined"
      label={label}
      value={value}
      classes={{ root: styles.root }}
      inputProps={{ className: styles.input }}
      InputLabelProps={{ className: styles.label }}
      SelectProps={{
        multiple: true,
        value: value,
        onChange: handleChange,
        renderValue: (selected: any) => (
          <div className={styles.valuesContainer}>
            {selected.map(
              (value: string, i: number, arr: string[]) =>
                `${value}${i !== arr.length - 1 ? ", " : " "}`,
            )}
          </div>
        ),
        MenuProps: {
          anchorOrigin: { vertical: "bottom", horizontal: "left" },
          transformOrigin: {
            vertical: "top",
            horizontal: "left",
          },
          getContentAnchorEl: null,
          PaperProps: {
            style: {
              maxHeight: ITEM_HEIGHT * 10 + ITEM_HEIGHT / 2,
              marginTop: "var(--spacing-m)",
            },
            className: styles.paper,
          },
        },
      }}
    >
      {options.map((option) => (
        <MenuItem disabled={disabled} key={option} value={option}>
          <Checkbox color="primary" checked={value.indexOf(option) > -1} />
          {option}
        </MenuItem>
      ))}
    </TextField>
  )
}
